/**
 * Calculate the remaining duration of an audiobook.
 * @param {number} totalLength - Total length of the audiobook in seconds
 * @param {number} currentLength - Length of the current chapter in seconds
 * @param {Array} chapters - List of all chapters
 * @param {object} currentChapter - Current chapter object
 *
 * @returns {object} Remaining duration object
 */
export const remainingDuration = (totalLength, currentLength, chapters, currentChapter) => {
  // Find the current chapter index
  const currentChapterIndex = chapters.findIndex((chapter) => chapter.name === currentChapter.name)

  // Calculate the total time listened so far
  const totalListened =
    chapters
      .slice(0, currentChapterIndex) // Get all chapters before the current chapter
      .reduce((acc, chapter) => acc + chapter.length, 0) + currentLength // Sum their lengths // Add the current length listened to in the current chapter

  // Calculate percentage remaining
  const percentageCompleted = (totalListened / totalLength) * 100

  // Calculate remaining time in seconds
  const remainingTime = totalLength - totalListened

  // Convert remaining time to "00H 00M" format
  const hours = Math.floor(remainingTime / 3600) // Get hours
  const minutes = Math.floor((remainingTime % 3600) / 60) // Get remaining minutes

  // Return the final object
  return {
    percentageCompleted: percentageCompleted.toFixed(0), // Rounded
    readableTime: `${hours}H ${minutes}M`,
  }
}
